import { useMutation, useQueryClient } from "@tanstack/react-query";
import AppContext from "PFApp/app_context";
import { editCurrentProfile } from "PFCore/services/current_profile";
import { CURRENT_PROFILE_ACTIONS } from "PFReducers/current_profile_reducer";
import { CurrentProfile } from "PFTypes";
import { MutationOptions } from "PFTypes/request_options";
import { useContext } from "react";

import profileKeys from "./query_keys";

export const useCurrentProfileUpdate = ({
  onSuccess,
  ...queryParams
}: MutationOptions<Partial<CurrentProfile>> = {}) => {
  const { dispatch } = useContext(AppContext);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Partial<CurrentProfile>): any => editCurrentProfile(payload),
    onSuccess: (resp: CurrentProfile, ...params) => {
      queryClient.setQueryData(profileKeys.profile("me"), resp);
      dispatch({
        type: CURRENT_PROFILE_ACTIONS.CURRENT_PROFILE_UPDATE,
        payload: resp
      });
      onSuccess?.(resp, ...params);
    },
    ...queryParams
  });
};
